import { Link } from 'react-router-dom'
import type { TagItem } from '@/legacy/components/ui/Typography'

export type CaseStudyCardItem = {
  title: string
  excerpt: string
  to: string
  tags: TagItem[]
  image?: {
    url: string
    alternativeText?: string
  }
  metrics: Array<{
    label: string
    value: string
  }>
}

type CaseStudyGridProps = {
  items: CaseStudyCardItem[]
  variant?: 'proof' | 'blog'
}

export const CaseStudyCard = ({ item, variant = 'proof' }: { item: CaseStudyCardItem; variant?: 'proof' | 'blog' }) => (
  <Link key={item.to} to={item.to} className={['case-study-card', `case-study-card--${variant}`].join(' ')}>
    <img
      className="case-study-card__media"
      src={item.image?.url ?? '/media/photos/article-components-hero.avif'}
      alt={item.image?.alternativeText ?? ''}
      loading="lazy"
      decoding="async"
    />
    <h3>{item.title}</h3>
    <p>{item.excerpt}</p>
    <dl className="case-study-card__metrics">
      {item.metrics.map((metric) => (
        <div key={metric.label}>
          <dt>{metric.label}</dt>
          <dd>{metric.value}</dd>
        </div>
      ))}
    </dl>
  </Link>
)

export const CaseStudyGrid = ({ items, variant = 'proof' }: CaseStudyGridProps) => (
  <div className={['case-study-grid', `case-study-grid--${variant}`].join(' ')}>
    {items.map((item) => (
      <CaseStudyCard key={item.to} item={item} variant={variant} />
    ))}
  </div>
)
